import { NetworkCalculationInletPanel } from "#routes/organization/networks/[networkId]/detail/NetworkCalculationTab/NetworkCalculationInletPanel";
import { NetworkCalculationSummaryPanel } from "#routes/organization/networks/[networkId]/detail/NetworkCalculationTab/NetworkCalculationSummaryPanel";
import { CalculationsViewFilterArea } from "#src/batteries-included-components/FilterAreas/CalculationsFilterAreas";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { NetworkCalculationConsumersPanel } from "#src/routes/organization/networks/[networkId]/detail/NetworkCalculationTab/NetworkCalculationConsumersPanel";
import React from "react";
import { NetworkUpdateStatusBanner } from "./NetworkUpdateStatusBanner";

export const NetworkCalculationTabV2 = () => {
  const [tableConfigStorageKey, viewConfigStorageKey, tableStateStorageKey] =
    useStorageKey(
      ["table-configuration", "view-configuration", "table-state"],
      "network-calculation"
    );
  // separate table config key for one of the panels, since table config key
  // can't be shared across two tables
  const [consumersTableConfigStorageKey, consumersTableStateStorageKey] =
    useStorageKey(
      ["table-configuration", "table-state"],
      "network-calculation-consumers"
    );

  return (
    <>
      <NetworkUpdateStatusBanner />
      <CalculationsViewFilterArea
        viewConfigStorageKey={viewConfigStorageKey}
        isPeriodDateRange={false}
      />
      <NetworkCalculationSummaryPanel
        viewConfigStorageKey={viewConfigStorageKey}
      />
      <NetworkCalculationInletPanel
        tableConfigStorageKey={tableConfigStorageKey}
        viewConfigStorageKey={viewConfigStorageKey}
        tableStateStorageKey={tableStateStorageKey}
      />
      <NetworkCalculationConsumersPanel
        viewConfigStorageKey={viewConfigStorageKey}
        tableConfigStorageKey={consumersTableConfigStorageKey}
        tableStateStorageKey={consumersTableStateStorageKey}
      />
    </>
  );
};
